<script>
import { mapGetters } from 'vuex'
import moment from "moment"

import Translatable from '@src/mixins/translatable.js'
import { trackEvent } from '@/src/utils/analytics';

export default {
  mixins: [
    Translatable,
  ],
  data() {
    return {
      contentData: {}
    }
  },
  computed: {
    ...mapGetters('eShop', [
      'orderData',
      'pdfLink',
      'loader'
    ]),
    pickupDate() {
      const date = this.orderData.order_info ? this.orderData.order_info.pickup_date : null
      return date && moment(date).format("DD/MM/YYYY")
    },
    orderInfo() {
      return this.orderData.order_info ? this.orderData.order_info : {}
    },
    isQr() {
      return this.orderData.checkout_delivery ? this.orderData.checkout_delivery === 'Coolpass' : false
    },
    isMobileApp() {
      return this.orderData.source ? this.orderData.source === 2 : false
    },
    returnENV(){
      return process.env.VUE_APP_BASE_URL
    },
    queryData() {
      const query = this.$route.query
      return {
        session_id: query.session_id,
        voucher_number: query.voucher_number,
        type: query.type,
        download: query.download
      }
    },
    queryValue() {
      return this.queryData.session_id || this.queryData.voucher_number
    },
    queryKey() {
      return this.queryData.session_id ? 'session_id' : 'voucher_number'
    },
  },
  async created() {
    const type = this.queryData.type
    const download = this.queryData.download

    this.$nextTick(() => {
      if (download) {
        window.location.href = this.pdfLink
      }
      if (!this.orderData.order_info && type !== 'payment_failed') {
        this.$router.push({ query: { session_id: 'null', type: 'not_found' } }).catch(() => {});
      }
      if (this.orderInfo.status === 4) {
        this.$router.push({ query: { session_id: this.queryData.session_id, type: 'cancelled' } }).catch(() => {});
      }
    })

    switch(type) {
      case 'order_accepted':
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_SuccessCaption#order_accepted'),
          subtitle: this.getTranslatedContent('ESHOP_SuccessCaptionSubtitle#order_accepted'),
          text: !this.isQr ? this.getTranslatedContent('ESHOP_SuccessTextCard#order_accepted').replace( "$pickupDate", this.pickupDate) :
            this.getTranslatedContent('ESHOP_SuccessTextQr#order_accepted'),
          buttonShow: true,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_make_another'),
          vaucher: `${this.getTranslatedContent('ESHOP_SuccessVaucherText#order_accepted')} ${this.orderInfo.voucher_number}`
        }

        if(sessionStorage.getItem('isAdClick') === 'true'){
          await trackEvent('sponsored_payment_successful', {
            event_category: 'google_ads',
          });
        }
        await trackEvent('payment_successful', {
          event_category: 'payment',
        });
        break;
      case 'changed':
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_SuccessCaption#order_changed'),
          subtitle: this.getTranslatedContent('ESHOP_SuccessCaptionSubtitle#order_changed'),
          text: this.getTranslatedContent('ESHOP_SuccessText#order_changed'),
          buttonShow: true,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_make_another'),
          vaucher: ''
        }

        if(sessionStorage.getItem('isAdClick') === 'true'){
          await trackEvent('sponsored_payment_successful', {
            event_category: 'google_ads',
          });
        }
        await trackEvent('payment_successful', {
          event_category: 'payment',
        });
        break;
      case 'cancel':
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_SuccessCaption#order_cancelled'),
          subtitle: this.getTranslatedContent('ESHOP_SuccessCaptionSubtitle#order_cancelled'),
          text: this.getTranslatedContent('ESHOP_SuccessText#order_cancelled'),
          buttonShow: false,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_go_back'),
          vaucher: ''
        }
        break;
      case 'cancelled':
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_ErrorCaption#cancelled'),
          subtitle: ``,
          text: this.getTranslatedContent('ESHOP_ErrorText#cancelled'),
          buttonShow: false,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_make_new'),
          vaucher: ''
        }
        break;
      case 'not_found':
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_ErrorCaption#not_found'),
          subtitle: ``,
          text: this.getTranslatedContent('ESHOP_ErrorText#not_found'),
          buttonShow: false,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_make_new'),
          vaucher: ''
        }
        break;
      case 'payment_failed':
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_ErrorCaption#payment_failed'),
          subtitle: ``,
          text: this.getTranslatedContent('ESHOP_ErrorText#payment_failed'),
          buttonShow: false,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_try_again'),
          vaucher: ''
        }
        break;
      default:
        this.contentData = {
          title: this.getTranslatedContent('ESHOP_ErrorCaption#not_found'),
          subtitle: ``,
          text: this.getTranslatedContent('ESHOP_ErrorText#not_found'),
          buttonShow: false,
          buttonText: this.getTranslatedContent('ESHOP_buttonText_make_new'),
          vaucher: ''
        }
        break;
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="eshop-title-container">
      <h3 class="eshop-title" v-html="contentData.title"></h3>
    </div>
    <p class="eshop-subtitle" v-html="contentData.subtitle">
    </p>
    <h3 class="eshop-title" v-html="contentData.vaucher"></h3>
    <p class="eshop-text" v-html="contentData.text"></p>
    <p v-if="isMobileApp && contentData.buttonShow" class="eshop-text" v-html="getTranslatedContent('ESHOP_mobileApp_text')"></p>
    <div class="buttons-container">
      <a v-if="contentData.buttonShow && !isQr" class="link" :href="pdfLink" download>
        <button class="button-cancel">{{ getTranslatedContent('ESHOP_buttonText_get_voucher') }}</button>
      </a>
      <a
        v-if="contentData.buttonShow && isQr"
        :href="`${returnENV}eshop?${queryKey}=${queryValue}&type=order_accepted&download=${pdfLink}`"
        class="link"
      >
        <button class="button-cancel">{{ getTranslatedContent('ESHOP_buttonText_get_voucher') }}</button>
      </a>
      <router-link
        v-if="orderInfo.status < 2 && contentData.buttonShow"
        :to="{ query: { [queryKey]: queryValue, type: 'manage' } }"
        class="link"
      >
        <button class="button-cancel">{{ getTranslatedContent('ESHOP_buttonText_manage') }}</button>
      </router-link>
      <router-link
        v-if="isQr && contentData.buttonShow"
        to="/plan-your-trip"
        class="link"
      >
        <button class="button-cancel">{{ getTranslatedContent('ESHOP_buttonText_download') }}</button>
      </router-link>
      <router-link :to="{ name: 'eshop' }" class="link">
        <button class="button-cancel">{{ contentData.buttonText }}</button>
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.buttons-container {
  display: flex;
  margin-top: 46px;
}

.eshop-title-container {
  margin-bottom: 15px;
  margin-top: 70px;
}

.eshop-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
  text-transform: uppercase;
  color: $dark-blue;
}

.eshop-subtitle {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: $black;
  margin: 12px 0;
}

::v-deep .eshop-text {
  margin-top: 15px;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $black;

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }
}

.link {
  display: block;
  outline: none;
  height: 48px;
  margin-right: 20px;
}

.button-cancel {
  min-width: 175px;
  height: 48px;
  border: 1px solid $gray;
  border-radius: 5px;
  background: $white;
  color: $gray;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  padding: 12px 30px;

  &:hover {
    border: 1px solid $white;
    height: 50px;
    background: $gray;
    color: $white;
  }
}

@media only screen and (max-width: $screen-width-xs) {
  .main-container {
    width: 100%;
  }

  .eshop-title-container {
    margin-top: 44px;
  }

  .eshop-title {
    font-size: 18px;
    line-height: 23px;
  }

  .buttons-container {
    display: flex;
    flex-direction: column;
    margin-top: 25px;
  }

  .link {
    margin: 0 0 15px;
  }

  .button-cancel {
    min-width: 100%;

    &:hover {
      border: 1px solid $gray;
      height: 48px;
      background: $white;
      color: $gray;
    }

    &:active {
      border: 1px solid $white;
      height: 50px;
      background: $gray;
      color: $white;
    }
  }
}
</style>
